<script setup name="Template4">
import { ref, onMounted, onUnmounted, inject } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
import { ElMessageBox } from "element-plus";

// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};
const id = ref("1");
const isMobile = ref(window.innerWidth <= 768);
// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);
const isLoggedIn = inject("isLoggedIn");
const handleMouseEnter = (sectionId) => {
  if (isLoggedIn.value) {
    return;
  }
  id.value = sectionId;
  //   展示子文字
};
const handleClick = (sectionId) => {
  id.value = sectionId;
};

// 生命周期钩子
onMounted(() => {});

onUnmounted(() => {});
</script>

<!-- 添加组件描述注释 -->
<!-- 4号模板组件：产品特性展示页面，左侧文字描述，右侧产品图片 -->

<template>
  <div class="template-5" ref="templateRef" :class="{ 'fade-in': isVisible }">
    <!-- 为每个content-section添加独立的ContainerCom -->
    <ContainerCom
      :allowFullScreenPlay="false"
      :contentId="props.templateId + '-container-' + id"
      :showDelete="true"
      @delete="handleDelete"
      :showOrderNum="true"
      @order="emit('order', $event)"
      v-if="!isMobile"
    >
      <div class="content-container">
        <!-- 第一个section -->
        <div class="section-wrapper">
          <!-- PC端：ContainerCom包含TextCom -->
          <div
            class="content-section pc-only"
            @mouseenter="handleMouseEnter('1')"
            @click="handleClick('1')"
          >
            <div class="title-container" :class="{ active: id === '1' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-1'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  v-if="id === '1'"
                  :floatAnimationEnabled="false"
                  :contentId="props.templateId + '-text-2'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>

          <!-- 移动端：ContainerCom -->
          <ContainerCom
            :allowFullScreenPlay="false"
            :contentId="props.templateId + '-container-1'"
            :showDelete="true"
            @delete="handleDelete"
            class="section-container mobile-only"
            :containerStyle="{
              width: '100%',
              height: '30vh',
              minHeight: '20vh',
            }"
          >
            <!-- 移动端ContainerCom内部为空 -->
          </ContainerCom>

          <!-- 移动端：TextCom放在ContainerCom下方 -->
          <div
            class="content-section mobile-only"
            @mouseenter="handleMouseEnter('1')"
            @click="handleClick('1')"
          >
            <div class="title-container" :class="{ active: id === '1' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-1'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  :contentId="props.templateId + '-text-2'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>
        </div>

        <!-- 第二个section -->
        <div class="section-wrapper">
          <!-- PC端：ContainerCom包含TextCom -->
          <div
            class="content-section pc-only"
            @mouseenter="handleMouseEnter('2')"
            @click="handleClick('2')"
          >
            <div class="title-container" :class="{ active: id === '2' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-3'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  v-if="id === '2'"
                  :floatAnimationEnabled="false"
                  :contentId="props.templateId + '-text-4'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>

          <!-- 移动端：ContainerCom -->
          <ContainerCom
            :contentId="props.templateId + '-container-2'"
            :showDelete="true"
            :allowFullScreenPlay="false"
            @delete="handleDelete"
            class="section-container mobile-only"
            :containerStyle="{
              width: '100%',
              height: '30vh',
              minHeight: '20vh',
            }"
          >
            <!-- 移动端ContainerCom内部为空 -->
          </ContainerCom>

          <!-- 移动端：TextCom放在ContainerCom下方 -->
          <div
            class="content-section mobile-only"
            @mouseenter="handleMouseEnter('2')"
            @click="handleClick('2')"
          >
            <div class="title-container" :class="{ active: id === '2' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-3'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  :contentId="props.templateId + '-text-4'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>
        </div>

        <!-- 第三个section -->
        <div class="section-wrapper">
          <!-- PC端：ContainerCom包含TextCom -->
          <div
            class="content-section pc-only"
            @mouseenter="handleMouseEnter('3')"
            @click="handleClick('3')"
          >
            <div class="title-container" :class="{ active: id === '3' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-5'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  v-if="id === '3'"
                  :floatAnimationEnabled="false"
                  :contentId="props.templateId + '-text-6'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>

          <!-- 移动端：ContainerCom -->
          <ContainerCom
            :contentId="props.templateId + '-container-3'"
            :showDelete="true"
            :allowFullScreenPlay="false"
            @delete="handleDelete"
            class="section-container mobile-only"
            :containerStyle="{
              width: '100%',
              height: '30vh',
              minHeight: '20vh',
            }"
          >
            <!-- 移动端ContainerCom内部为空 -->
          </ContainerCom>

          <!-- 移动端：TextCom放在ContainerCom下方 -->
          <div
            class="content-section mobile-only"
            @mouseenter="handleMouseEnter('3')"
            @click="handleClick('3')"
          >
            <div class="title-container" :class="{ active: id === '3' }">
              <div class="title-en-wrapper">
                <TextCom
                  :contentId="props.templateId + '-text-5'"
                  class="title-en"
                />
                <span class="arrow-icon"></span>
              </div>
              <transition name="fade">
                <TextCom
                  :contentId="props.templateId + '-text-6'"
                  class="title-zh"
                />
              </transition>
            </div>
          </div>
        </div>
      </div>
    </ContainerCom>
    <div class="content-container" v-else>
      <!-- 第一个section -->
      <div class="section-wrapper">
        <!-- PC端：ContainerCom包含TextCom -->
        <div
          class="content-section pc-only"
          @mouseenter="handleMouseEnter('1')"
          @click="handleClick('1')"
        >
          <div class="title-container" :class="{ active: id === '1' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-1'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                v-if="id === '1'"
                :floatAnimationEnabled="false"
                :contentId="props.templateId + '-text-2'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>

        <!-- 移动端：ContainerCom -->
        <ContainerCom
          :allowFullScreenPlay="false"
          :contentId="props.templateId + '-container-1'"
          :showDelete="true"
          @delete="handleDelete"
          class="section-container mobile-only"
          :containerStyle="{
            width: '100%',
            height: '30vh',
            minHeight: '20vh',
          }"
        >
          <!-- 移动端ContainerCom内部为空 -->
        </ContainerCom>

        <!-- 移动端：TextCom放在ContainerCom下方 -->
        <div
          class="content-section mobile-only"
          @mouseenter="handleMouseEnter('1')"
          @click="handleClick('1')"
        >
          <div class="title-container" :class="{ active: id === '1' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-1'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                :contentId="props.templateId + '-text-2'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>
      </div>

      <!-- 第二个section -->
      <div class="section-wrapper">
        <!-- PC端：ContainerCom包含TextCom -->
        <div
          class="content-section pc-only"
          @mouseenter="handleMouseEnter('2')"
          @click="handleClick('2')"
        >
          <div class="title-container" :class="{ active: id === '2' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-3'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                v-if="id === '2'"
                :floatAnimationEnabled="false"
                :contentId="props.templateId + '-text-4'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>

        <!-- 移动端：ContainerCom -->
        <ContainerCom
          :contentId="props.templateId + '-container-2'"
          :showDelete="true"
          :allowFullScreenPlay="false"
          @delete="handleDelete"
          class="section-container mobile-only"
          :containerStyle="{
            width: '100%',
            height: '30vh',
            minHeight: '20vh',
          }"
        >
          <!-- 移动端ContainerCom内部为空 -->
        </ContainerCom>

        <!-- 移动端：TextCom放在ContainerCom下方 -->
        <div
          class="content-section mobile-only"
          @mouseenter="handleMouseEnter('2')"
          @click="handleClick('2')"
        >
          <div class="title-container" :class="{ active: id === '2' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-3'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                :contentId="props.templateId + '-text-4'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>
      </div>

      <!-- 第三个section -->
      <div class="section-wrapper">
        <!-- PC端：ContainerCom包含TextCom -->
        <div
          class="content-section pc-only"
          @mouseenter="handleMouseEnter('3')"
          @click="handleClick('3')"
        >
          <div class="title-container" :class="{ active: id === '3' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-5'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                v-if="id === '3'"
                :floatAnimationEnabled="false"
                :contentId="props.templateId + '-text-6'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>

        <!-- 移动端：ContainerCom -->
        <ContainerCom
          :contentId="props.templateId + '-container-3'"
          :showDelete="true"
          :allowFullScreenPlay="false"
          @delete="handleDelete"
          class="section-container mobile-only"
          :containerStyle="{
            width: '100%',
            height: '30vh',
            minHeight: '20vh',
          }"
        >
          <!-- 移动端ContainerCom内部为空 -->
        </ContainerCom>

        <!-- 移动端：TextCom放在ContainerCom下方 -->
        <div
          class="content-section mobile-only"
          @mouseenter="handleMouseEnter('3')"
          @click="handleClick('3')"
        >
          <div class="title-container" :class="{ active: id === '3' }">
            <div class="title-en-wrapper">
              <TextCom
                :contentId="props.templateId + '-text-5'"
                class="title-en"
              />
              <span class="arrow-icon"></span>
            </div>
            <transition name="fade">
              <TextCom
                :contentId="props.templateId + '-text-6'"
                class="title-zh"
              />
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* 基础样式，保持PC端原有样式不变 */
.template-5 {
  background-color: #222;
}
.content-container {
  display: flex;
  height: 90vh;
  /* flex-direction: column; */
  /* background-color: #222; */
}

/* 新增：section包装器 */
.section-wrapper {
  position: relative;
  width: 33%;
  height: 100%;
}

/* 每个section的容器样式 */
.section-container {
  width: 100%;
  height: 100%;
  position: relative;
  /* 竖线分隔 */
  border-right: 1px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
}
/* 移除最后一个section容器的右边框 */
.section-wrapper:last-child .section-container {
  border-right: none;
}
.content-section {
  width: 100%;
  padding: 0 3.6458vw;
  position: relative;
  transition: width 0.5s ease-out; /* 宽度过渡效果 */
  height: 100%;
  border-right: 1px solid rgba(255, 255, 255, 0.3);
}

/* 鼠标悬停时增加宽度 */
.section-wrapper {
  transition: width 0.5s ease-out; /* 添加平滑过渡动画 */
}

/* PC端样式 */
@media (min-width: 1024px) {
  .section-wrapper:hover {
    width: 40%; /* 增加宽度，相对于父容器 */
    z-index: 10;
    
  }
  .content-container:hover .section-wrapper:not(:hover) {
  width: 30%; /* 非悬停section容器宽度减小 */
  transition: width 0.5s ease-out; /* 添加平滑过渡动画 */
}
}

/* 其他section相应缩小 */

.title-container {
  position: absolute;
  bottom: 10%;
}

/* 为所有title-en添加过渡效果 */
.title-en {
  transition: transform 0.5s ease-out;
  display: inline-block;
}

/* 当title-container激活时，第一个TextCom缓慢上升 */
.title-container.active .title-en {
  transform: translateY(-50px); /* 调整上升距离 */
}

/* title-en和箭头图标包装器 */
.title-en-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
  position: relative;
}

/* 箭头图标样式 */
.arrow-icon {
  width: 4rem; /* 明确宽度 */
  height: 4rem; /* 明确高度，与title-en文字高度匹配 */
  background-image: url("../assets/arrow-right-green.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  opacity: 0;
  transform: translate(-20px, -50px);
  transition: opacity 0.3s ease-out, transform 0.3s ease-out;
  display: inline-block;
}

/* 鼠标悬停时显示箭头 */
.content-section:hover .arrow-icon {
  opacity: 1;
  /* transform: translateX(0); */
  transform: translate(0px, -50px);
}

/* 中文标题初始状态和过渡效果 */
.title-zh {
  opacity: 1; /* 最终状态直接设置为1 */
}

/* 自定义过渡效果：出现时从0.5到1淡入，消失时直接消失 */
.fade-enter-active {
  transition: opacity 0.5s ease-out;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter-from {
  opacity: 0; /* 进入时从0.5开始 */
}
.fade-leave-to {
  opacity: 0; /* 离开时直接消失 */
}

/* 初始状态：隐藏移动端元素 */
.mobile-only {
  display: none;
}

/* 移动端适配 */
@media (max-width: 1024px) {
  /* 调整section容器内边距 */
  .content-section {
    padding: 0 2.5vw;
  }

  .arrow-icon {
    width: 3.5rem;
    height: 3.5rem;
  }
}

@media (max-width: 768px) {
  /* 显示移动端元素，隐藏PC端元素 */
  .pc-only {
    display: none;
  }
  .mobile-only {
    display: block;
  }

  /* 改为垂直排列 */
  .content-container {
    flex-direction: column;
    height: auto;
    min-height: 100vh;
  }

  /* 每个section包装器在移动端下占满宽度 */
  .section-wrapper {
    width: 100%;
    height: auto;
    margin-bottom: 2rem;
  }

  /* 移除最后一个section包装器的外边距 */
  .section-wrapper:last-child {
    margin-bottom: 0;
  }

  /* 每个section容器在移动端下占满宽度 */
  .section-container {
    width: 100%;
    height: auto;
    min-height: 20vh;
    border-right: none;
    border-bottom: none;
    overflow: visible;
    transition: none;
    position: relative;
  }

  /* 调整移动端section内部样式 */
  .mobile-only.content-section {
    width: 100%;
    padding: 5vw;
    border-right: none;
    transition: none;
    height: auto;
    min-height: auto;
    display: block;
    align-items: flex-start;
    position: relative;
    z-index: 1;
    background-color: #222;
  }

  /* 禁用PC端的悬停效果 */
  .content-section:hover {
    width: 100%;
  }

  .content-container:hover .section-container:not(:hover) {
    width: 100%;
  }

  /* 调整标题容器位置 */
  .title-container {
    position: relative;
    bottom: auto;
    margin: 2rem 0;
    width: 100%;
  }

  /* 调整箭头图标大小 */
  .arrow-icon {
    width: 3rem;
    height: 3rem;
    transform: translate(0, -30px);
  }

  /* 触摸设备上，直接显示箭头和中文标题 */
  .content-section .arrow-icon {
    opacity: 1;
  }

  /* 调整标题上升距离 */
  .title-container.active .title-en {
    transform: translateY(-30px);
  }
}

@media (max-width: 480px) {
  .section-container {
    min-height: 15vh;
  }

  .mobile-only.content-section {
    padding: 6vw;
  }

  .title-en-wrapper {
    gap: 8px;
  }

  .arrow-icon {
    width: 2.5rem;
    height: 2.5rem;
  }

  /* 进一步调整标题上升距离 */
  .title-container.active .title-en {
    transform: translateY(-20px);
  }
}
</style>
